import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

interface MenuItem {
  label: string;
  route?: string;
  icon?: string;
  isSection?: boolean;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  isOpen = false;

  mainMenuItems: MenuItem[] = [
    { label: 'Key Controls Compliance and Metrics', route: '/main-dashboard' },
    { label: 'Control Assurance', route: '/control-assurance' },
    { label: 'Incident Management', route: '/incident-management' },
    { label: 'Risks High', route: '/risks' },
    { label: 'Data Source', route: '/data-source' },
  ];

  bottomMenuItems: MenuItem[] = [
    { label: 'Settings', icon: 'settings' },
    { label: 'Profile', icon: 'profile' },
  ];

  toggleSidebar(): void {
    this.isOpen = !this.isOpen;
  }
}
